import { fetchWithAuth } from './api';

const REST_BASE = (import.meta.env.VITE_REST_API_URL ?? '').replace(/\/$/, '');

export async function deleteSession(sessionId: string): Promise<void> {
  const response = await fetchWithAuth(`${REST_BASE}/sessions/${sessionId}`, {
    method: 'DELETE',
  });
  if (!response.ok && response.status !== 204) {
    throw new Error(`DELETE /sessions/${sessionId} returned ${response.status}`);
  }
}

export async function reopenSession(sessionId: string): Promise<void> {
  const response = await fetchWithAuth(`${REST_BASE}/sessions/${sessionId}/reopen`, {
    method: 'POST',
  });
  if (!response.ok) {
    throw new Error(`POST /sessions/${sessionId}/reopen returned ${response.status}`);
  }
}
